import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, SparklesIcon, BotIcon, SearchIcon, Loader2Icon, CheckCircle2Icon } from 'lucide-react';
import { Button } from '../ui/Button';
export function OpenclawHero() {
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8" data-id="element-5447">
      <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-100 p-8 md:p-12 lg:p-16 relative overflow-hidden" data-id="element-5448">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] bg-blue-50/50 rounded-full blur-3xl -z-10 pointer-events-none" data-id="element-5449" />

        <div className="relative z-10" data-id="element-5450">
          <a href="#/features" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-slate-900 transition-colors mb-8" data-id="element-5451">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-5452" /> All features
          </a>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-5453">
            {/* Left Column: Copy & CTAs */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} className="max-w-2xl" data-id="element-5454">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-50 text-blue-600 rounded-full text-sm font-bold mb-6 border border-blue-100" data-id="element-5455">
                <SparklesIcon className="w-4 h-4" data-id="element-5456" />
                Openclaw for sales
              </div>

              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-slate-900 mb-8 leading-[1.05]" data-id="element-5457">
                Your AI agent for <br data-id="element-5458" />
                <span className="text-blue-600" data-id="element-5459">local sales</span>
              </h1>

              <p className="text-xl sm:text-2xl text-slate-600 mb-8 max-w-lg leading-relaxed" data-id="element-5460">
                Stop manually prospecting. Openmart's AI agent uses our 200M+
                local business database to find, score, and draft outreach for
                your ideal accounts automatically.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-5461">
                <Button href="http://app.openmart.com/register" variant="primary" size="lg" arrow data-id="element-5462">
                  Try for free
                </Button>
              </div>

              {/* Static Stats Bar */}
              <div className="flex gap-12 pt-8 border-t border-slate-100" data-id="element-5463">
                <div data-id="element-5464">
                  <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-5465">
                    200M+
                  </div>
                  <div className="text-sm text-slate-500 font-medium" data-id="element-5466">
                    Local businesses
                  </div>
                </div>
                <div data-id="element-5467">
                  <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-5468">
                    10x
                  </div>
                  <div className="text-sm text-slate-500 font-medium" data-id="element-5469">
                    Faster prospecting
                  </div>
                </div>
                <div data-id="element-5470">
                  <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-5471">
                    24/7
                  </div>
                  <div className="text-sm text-slate-500 font-medium" data-id="element-5472">
                    Automated sourcing
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Right Column: Visual */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative" data-id="element-5473">
              <div className="bg-white rounded-[2.5rem] p-6 sm:p-8 relative z-10 border border-slate-200 shadow-xl overflow-hidden" data-id="element-5474">
                <div className="absolute top-0 right-0 w-64 h-64 bg-blue-400/10 blur-3xl rounded-full pointer-events-none" data-id="element-5475" />

                <div className="flex items-center gap-4 mb-6" data-id="element-5476">
                  <div className="w-12 h-12 bg-blue-100 rounded-2xl flex items-center justify-center" data-id="element-5477">
                    <BotIcon className="w-6 h-6 text-blue-600" data-id="element-5478" />
                  </div>
                  <div data-id="element-5479">
                    <h3 className="text-xl font-bold text-slate-900" data-id="element-5480">
                      Openmart AI Agent
                    </h3>
                    <p className="text-sm text-slate-500" data-id="element-5481">
                      Executing sales workflow
                    </p>
                  </div>
                </div>

                <div className="space-y-5 pl-1" data-id="element-5482">
                  {/* User message */}
                  <div className="flex justify-end mb-6" data-id="element-5483">
                    <div className="bg-blue-600 rounded-2xl rounded-tr-sm px-5 py-4 text-[13px] leading-relaxed text-white max-w-[85%] shadow-md shadow-blue-600/10" data-id="element-5484">
                      help me prospect dental clinics in Columbus Ohio that have
                      multiple locations but poor reviews
                    </div>
                  </div>

                  {/* AI response */}
                  <div className="flex items-center gap-3" data-id="element-5485">
                    <div className="w-7 h-7 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-5486">
                      <SparklesIcon className="w-3.5 h-3.5 text-blue-600" data-id="element-5487" />
                    </div>
                    <span className="text-sm font-medium text-slate-700" data-id="element-5488">
                      Thinking...
                    </span>
                    <Loader2Icon className="w-3.5 h-3.5 animate-spin text-blue-500" data-id="element-5489" />
                  </div>

                  <div className="flex items-center gap-3 pl-10" data-id="element-5490">
                    <SearchIcon className="w-4 h-4 text-slate-400" data-id="element-5491" />
                    <span className="text-sm text-slate-500" data-id="element-5492">
                      Loading tools
                    </span>
                    <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-blue-50 text-blue-600 border border-blue-100" data-id="element-5493">
                      Result
                    </span>
                  </div>

                  <div className="pl-10 mt-1 space-y-2" data-id="element-5494">
                    <div className="p-3 bg-slate-50 rounded-lg border border-slate-100 text-[11px] font-mono text-slate-500 leading-relaxed" data-id="element-5495">
                      <div className="text-slate-400" data-id="element-5496">
                        → search_local_businesses(200M+ records)
                      </div>
                      <div className="text-slate-400" data-id="element-5497">
                        → filter_by_criteria(location="Columbus, OH",
                        category="Dental")
                      </div>
                      <div className="text-slate-400" data-id="element-5498">
                        → enrich_contacts(decision_makers=true)
                      </div>
                      <div className="text-slate-400" data-id="element-5499">
                        → score_leads(priority="low_reviews, multi_location")
                      </div>
                      <div className="text-blue-600 font-medium flex items-center gap-2 mt-1" data-id="element-5500">
                        → draft_emails(personalize=true)
                        <span className="flex gap-0.5" data-id="element-5501">
                          <span className="w-1 h-1 rounded-full bg-blue-400 animate-pulse" data-id="element-5502" />
                          <span className="w-1 h-1 rounded-full bg-blue-400 animate-pulse" style={{
                          animationDelay: '0.2s'
                        }} data-id="element-5503" />
                          <span className="w-1 h-1 rounded-full bg-blue-400 animate-pulse" style={{
                          animationDelay: '0.4s'
                        }} data-id="element-5504" />
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Mini Result Card */}
                  <motion.div initial={{
                  opacity: 0,
                  y: 10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  delay: 1.5,
                  duration: 0.5
                }} className="pl-10 mt-4" data-id="element-5505">
                    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-3 flex items-center justify-between" data-id="element-5506">
                      <div className="flex items-center gap-3" data-id="element-5507">
                        <div className="w-8 h-8 rounded-full bg-emerald-50 flex items-center justify-center" data-id="element-5508">
                          <CheckCircle2Icon className="w-4 h-4 text-emerald-500" data-id="element-5509" />
                        </div>
                        <div data-id="element-5510">
                          <div className="text-[13px] font-bold text-slate-900" data-id="element-5511">
                            Found 42 qualified leads
                          </div>
                          <div className="text-[11px] text-slate-500" data-id="element-5512">
                            Scored and drafted 42 emails
                          </div>
                        </div>
                      </div>
                      <div className="flex -space-x-2" data-id="element-5513">
                        <div className="w-6 h-6 rounded-full bg-blue-100 border-2 border-white flex items-center justify-center text-[9px] font-bold text-blue-700" data-id="element-5514">
                          98
                        </div>
                        <div className="w-6 h-6 rounded-full bg-blue-50 border-2 border-white flex items-center justify-center text-[9px] font-bold text-blue-600" data-id="element-5515">
                          94
                        </div>
                        <div className="w-6 h-6 rounded-full bg-slate-100 border-2 border-white flex items-center justify-center text-[9px] font-bold text-slate-500" data-id="element-5516">
                          +40
                        </div>
                      </div>
                    </div>
                  </motion.div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}